import {
  AgentThreadAssistantIteration,
  AgentThreadMessage,
  AgentThreadMessageItem,
} from "@/store/chat.types";
import {
  isAssistMessage,
  isCheckpointMessage,
  isRtcMessage,
  isToolMessage,
  isToolResponseMessage,
  isUserMessage,
} from "@/util/message";

export function assembleMessageList(
  messages: AgentThreadMessage[]
): AgentThreadMessageItem[] {
  const messageList: AgentThreadMessageItem[] = [];

  let iteration: AgentThreadAssistantIteration = {
    id: "",
    messages: [],
  };

  let toolMessages: AgentThreadMessage[] = [];
  const toolMessageIndexByToolId = new Map<string, number>();

  const flushToolMessages = () => {
    if (toolMessages.length === 0) {
      return;
    }
    iteration.messages.push(toolMessages);
    toolMessages = [];
    toolMessageIndexByToolId.clear();
  };

  const commitIteration = () => {
    flushToolMessages();
    if (!iteration.id) {
      const first = iteration.messages[0];
      const suffix = Array.isArray(first) ? first[0].id : first.id;
      iteration.id = `iteration-${suffix}`;
    }
    messageList.push(iteration);
    iteration = {
      id: "",
      messages: [],
    };
  };

  for (let i = 0; i < messages.length; i++) {
    const currentMessage = messages[i];

    // Handle checkpoint messages within the iteration (like tool messages)
    if (isCheckpointMessage(currentMessage)) {
      flushToolMessages();
      iteration.messages.push(currentMessage);
      continue;
    }

    if (isAssistMessage(currentMessage)) {
      // Handle RTC messages same as tool messages
      if (isToolMessage(currentMessage) || isRtcMessage(currentMessage)) {
        const toolCallId = currentMessage.content?.tool_call_id;
        if (
          toolCallId &&
          isToolResponseMessage(currentMessage) &&
          toolMessageIndexByToolId.has(toolCallId)
        ) {
          const idx = toolMessageIndexByToolId.get(toolCallId)!;
          toolMessages[idx] = currentMessage;
          continue;
        }
        toolMessages.push(currentMessage);
        if (toolCallId) {
          toolMessageIndexByToolId.set(toolCallId, toolMessages.length - 1);
        }
      } else {
        if (!currentMessage.content.content) {
          // 忽略空 content 的 Assistant 消息
          continue;
        }
        flushToolMessages();
        iteration.messages.push(currentMessage);
      }
    }
    if (isUserMessage(currentMessage)) {
      if (toolMessages.length > 0) {
        flushToolMessages();
        commitIteration();
      }
      if (iteration.messages.length > 0) {
        commitIteration();
      }
      messageList.push(currentMessage);
    }
  }
  flushToolMessages();

  // 处理最后一个 iteration（如果存在的话）
  if (iteration.messages.length > 0) {
    commitIteration();
  }
  return messageList;
}
